var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsOptional, IsString, ValidateNested } from "class-validator";
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["DATAWAREHOUSE_BIGQUERY"] = "DATAWAREHOUSE_BIGQUERY";
    DataSourceType["DATAWAREHOUSE_SNOWFLAKE"] = "DATAWAREHOUSE_SNOWFLAKE";
})(DataSourceType || (DataSourceType = {}));
export const DATA_SOURCE_TYPE_DISPLAY_MAP = {
    [DataSourceType.DATAWAREHOUSE_BIGQUERY]: "BigQuery",
    [DataSourceType.DATAWAREHOUSE_SNOWFLAKE]: "Snowflake",
};
export var DataClassificationStatus;
(function (DataClassificationStatus) {
    DataClassificationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DataClassificationStatus["COMPLETED"] = "COMPLETED";
})(DataClassificationStatus || (DataClassificationStatus = {}));
export var DataSourceHealthStatus;
(function (DataSourceHealthStatus) {
    DataSourceHealthStatus["UNKNOWN"] = "UNKNOWN";
    DataSourceHealthStatus["HEALTHY"] = "HEALTHY";
    DataSourceHealthStatus["SERVICE_DISRUPTION"] = "SERVICE_DISRUPTION";
    DataSourceHealthStatus["PARTIAL_SERVICE_DISRUPTION"] = "PARTIAL_SERVICE_DISRUPTION";
    DataSourceHealthStatus["OPERATIONAL"] = "OPERATIONAL";
})(DataSourceHealthStatus || (DataSourceHealthStatus = {}));
export class DataWarehouseClassificationInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], DataWarehouseClassificationInput.prototype, "id", void 0);
__decorate([
    IsString()
], DataWarehouseClassificationInput.prototype, "dataSourceId", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], DataWarehouseClassificationInput.prototype, "enabled", void 0);
__decorate([
    IsEnum(DataClassificationStatus)
], DataWarehouseClassificationInput.prototype, "status", void 0);
export class DataWarehouseConnectorInput {
}
__decorate([
    IsEnum(DataSourceType)
], DataWarehouseConnectorInput.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional()
], DataWarehouseConnectorInput.prototype, "authConfig", void 0);
export class DataWarehouseConnectorDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(DataSourceType)
], DataWarehouseConnectorDto.prototype, "type", void 0);
export class DataWarehouseDataSourceInput {
}
__decorate([
    IsString(),
    IsOptional()
], DataWarehouseDataSourceInput.prototype, "id", void 0);
__decorate([
    IsEnum(DataSourceType)
], DataWarehouseDataSourceInput.prototype, "type", void 0);
__decorate([
    IsString()
], DataWarehouseDataSourceInput.prototype, "patientIdFieldName", void 0);
__decorate([
    IsString()
], DataWarehouseDataSourceInput.prototype, "schema", void 0);
export class DataSourceMetadata {
}
export class BigQueryDataSourceMetadata extends DataSourceMetadata {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], BigQueryDataSourceMetadata.prototype, "datasetId", void 0);
__decorate([
    IsString()
], BigQueryDataSourceMetadata.prototype, "projectId", void 0);
__decorate([
    IsString(),
    IsOptional()
], BigQueryDataSourceMetadata.prototype, "description", void 0);
__decorate([
    IsString(),
    IsOptional()
], BigQueryDataSourceMetadata.prototype, "location", void 0);
__decorate([
    IsString(),
    IsOptional()
], BigQueryDataSourceMetadata.prototype, "creationTime", void 0);
__decorate([
    IsString(),
    IsOptional()
], BigQueryDataSourceMetadata.prototype, "lastModifiedTime", void 0);
export class DataSourceInput {
}
__decorate([
    IsString(),
    IsOptional()
], DataSourceInput.prototype, "id", void 0);
__decorate([
    IsString()
], DataSourceInput.prototype, "name", void 0);
__decorate([
    IsEnum(DataSourceType)
], DataSourceInput.prototype, "type", void 0);
__decorate([
    IsString()
], DataSourceInput.prototype, "authConfig", void 0);
__decorate([
    Type(() => BigQueryDataSourceMetadata),
    IsOptional()
], DataSourceInput.prototype, "metadata", void 0);
export class DataSourceSearchInput {
}
__decorate([
    IsString()
], DataSourceSearchInput.prototype, "name", void 0);
export class DataSourceTablesInput {
}
__decorate([
    IsArray()
], DataSourceTablesInput.prototype, "tableNames", void 0);
export class DataSourceDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], DataSourceDto.prototype, "id", void 0);
__decorate([
    IsString()
], DataSourceDto.prototype, "name", void 0);
__decorate([
    IsEnum(DataSourceType)
], DataSourceDto.prototype, "type", void 0);
__decorate([
    IsString()
], DataSourceDto.prototype, "authConfig", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], DataSourceDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], DataSourceDto.prototype, "updatedAt", void 0);
__decorate([
    Type(() => BigQueryDataSourceMetadata),
    IsOptional()
], DataSourceDto.prototype, "metadata", void 0);
__decorate([
    IsEnum(DataSourceHealthStatus)
], DataSourceDto.prototype, "healthStatus", void 0);
export class DataSourceDtoWithInProgressClassification extends DataSourceDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsArray()
], DataSourceDtoWithInProgressClassification.prototype, "inProgressClassificationRunIds", void 0);
export class DataWarehouseAddedEntityDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], DataWarehouseAddedEntityDto.prototype, "dataSourceId", void 0);
__decorate([
    IsString()
], DataWarehouseAddedEntityDto.prototype, "studyId", void 0);
__decorate([
    IsString(),
    IsOptional()
], DataWarehouseAddedEntityDto.prototype, "studyTitle", void 0);
__decorate([
    IsString()
], DataWarehouseAddedEntityDto.prototype, "dataWarehouseClassificationEntityId", void 0);
__decorate([
    IsString()
], DataWarehouseAddedEntityDto.prototype, "name", void 0);
__decorate([
    IsString()
], DataWarehouseAddedEntityDto.prototype, "addedName", void 0);
__decorate([
    IsString()
], DataWarehouseAddedEntityDto.prototype, "policy", void 0);
__decorate([
    IsString()
], DataWarehouseAddedEntityDto.prototype, "metadata", void 0);
__decorate([
    IsBoolean()
], DataWarehouseAddedEntityDto.prototype, "isAdded", void 0);
__decorate([
    IsString(),
    IsOptional()
], DataWarehouseAddedEntityDto.prototype, "errorMessage", void 0);
export class DataWarehouseUserDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], DataWarehouseUserDto.prototype, "dataSourceId", void 0);
__decorate([
    IsString()
], DataWarehouseUserDto.prototype, "studyId", void 0);
__decorate([
    IsString()
], DataWarehouseUserDto.prototype, "userId", void 0);
__decorate([
    IsString()
], DataWarehouseUserDto.prototype, "email", void 0);
__decorate([
    IsBoolean()
], DataWarehouseUserDto.prototype, "isAdded", void 0);
__decorate([
    IsString(),
    IsOptional()
], DataWarehouseUserDto.prototype, "errorMessage", void 0);
export class DatasetDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], DatasetDto.prototype, "datasetId", void 0);
__decorate([
    IsString()
], DatasetDto.prototype, "projectId", void 0);
export class TableColumnDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], TableColumnDto.prototype, "id", void 0);
__decorate([
    IsString()
], TableColumnDto.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional()
], TableColumnDto.prototype, "description", void 0);
__decorate([
    IsString()
], TableColumnDto.prototype, "dataType", void 0);
__decorate([
    IsString()
], TableColumnDto.prototype, "mode", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], TableColumnDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], TableColumnDto.prototype, "updatedAt", void 0);
__decorate([
    IsString()
], TableColumnDto.prototype, "dataWarehouseEntityId", void 0);
export class TableDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], TableDto.prototype, "id", void 0);
__decorate([
    IsString()
], TableDto.prototype, "dataSourceId", void 0);
__decorate([
    IsString()
], TableDto.prototype, "name", void 0);
__decorate([
    IsBoolean()
], TableDto.prototype, "registered", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], TableDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], TableDto.prototype, "updatedAt", void 0);
__decorate([
    IsString()
], TableDto.prototype, "metadata", void 0);
__decorate([
    Type(() => TableColumnDto),
    ValidateNested({ each: true }),
    IsArray()
], TableDto.prototype, "columns", void 0);
export var DataWarehouseAuthStatus;
(function (DataWarehouseAuthStatus) {
    DataWarehouseAuthStatus["NOTHING"] = "NOTHING";
    DataWarehouseAuthStatus["INITING"] = "INITING";
    DataWarehouseAuthStatus["NO_DB_RECORD"] = "NO_DB_RECORD";
    DataWarehouseAuthStatus["NO_CONFIG"] = "NO_CONFIG";
    DataWarehouseAuthStatus["INCORRECT_CONFIG"] = "INCORRECT_CONFIG";
    DataWarehouseAuthStatus["CONFIG_FAILED"] = "CONFIG_FAILED";
    DataWarehouseAuthStatus["RUNNING"] = "RUNNING";
    DataWarehouseAuthStatus["EXCEPTION"] = "EXCEPTION";
})(DataWarehouseAuthStatus || (DataWarehouseAuthStatus = {}));
